<style scoped>
</style>

<template>
	<div class="vue-box">
		<div class="c-panel">

			<!-- 参数栏 -->
			<div class="c-title">检索参数</div>
			<el-form size="mini" :inline="true" @submit.native.prevent >
        <el-form-item style="min-width: 0px;">
        <el-button type="primary" icon="el-icon-plus" @click="add()">添加</el-button>
        </el-form-item>
				<el-form-item label="名称查询：">
					<el-input v-model="p.name" placeholder="模糊查询"></el-input>
				</el-form-item>


        <el-form-item label="校区：">
          <el-select size="mini" v-model="p.campus">
            <el-option label="不限" :value="''"></el-option>
            <el-option v-for="campus in campusList" :label="campus.name" :value="campus.id" :key="campus.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="状态：">
          <el-select size="mini" v-model="p.status">
            <el-option label="正常" :value="0"></el-option>
            <el-option label="禁用" :value="1"></el-option>
            <el-option label="不限" :value="''"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item style="min-width: 0px;">
          <el-button type="primary" icon="el-icon-search" @click="p.pageNo = 1; f5()">查询</el-button>

        </el-form-item>
			</el-form>
			<!-- 数据列表 -->
			<div class="c-title">数据列表</div>
			<el-table :data="dataList" size="mini">
        <el-table-column label="学生状态" width="80px">
          <template slot-scope="s">
            <el-tag class="c-tag" effect="dark" size="mini" color="#282" v-if="s.row.status==0" @click="changeStatus(s.row.id,s.row.status)">正常</el-tag>
            <el-tag class="c-tag" effect="dark" size="mini" color="#f22" v-if="s.row.status==1" @click="changeStatus(s.row.id,s.row.status)">禁用</el-tag>
          </template>
        </el-table-column>
				<el-table-column label="姓名" prop="name"  width="80px"></el-table-column>
				<el-table-column label="性别" width="60px">
					<template slot-scope="s">
						<b style="color: #000000; ">{{s.row.sex==0?'男':'女'}}</b>
					</template>
				</el-table-column>

        <el-table-column label="手机" prop="phoneNum" width="100px"></el-table-column>
        <el-table-column label="校区" width="150px">
          <template slot-scope="s">
            <b style="color: #000000; ">{{getCampusName(s.row.campus)}}</b>
          </template>
        </el-table-column>
        <el-table-column label="入学日期" width="150px">
          <template slot-scope="s"><span>{{sa.forDate(s.row.birthday, 2)}}</span></template>
        </el-table-column>
        <el-table-column label="剩余课时" prop="hour" width="80px"></el-table-column>
        <el-table-column label="会员等级"  width="80px">
          <template slot-scope="s">
            <b style="color: #000000; ">{{getVipInfo(s.row.vip)}}</b>
          </template>
        </el-table-column>
				<el-table-column label="操作" width="240px">
					<template slot-scope="s">
<!--						<el-button class="c-btn" type="success"  icon="el-icon-view" @click="get(s.row)">查看</el-button>-->
						<el-button class="c-btn" type="primary" icon="el-icon-edit" @click="update(s.row)">修改</el-button>
            <el-button class="c-btn" type="primary" icon="el-icon-edit" @click="updateHour(s.row)">修改课时</el-button>
<!--						<el-button class="c-btn" type="danger" icon="el-icon-delete" @click="del(s.row)">删除</el-button>-->
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页 -->
			<div class="page-box">
				<el-pagination background
					layout="total, prev, pager, next, sizes, jumper"
					:current-page.sync="p.pageNo"
					:page-size.sync="p.pageSize"
					:total="dataCount"
					:page-sizes="[1, 10, 20, 30, 40, 50, 100]"
					@current-change="f5()"
					@size-change="f5()">
				</el-pagination>
			</div>
		</div>

		<!-- 增改组件 -->
		<add-or-update ref="add-or-update"></add-or-update>
    <hour-or-update ref="hour-or-update"></hour-or-update>

	</div>
</template>

<script>
	import addOrUpdate from './student-list-add.vue';
  import hourOrUpdate from './student-list-hour.vue';
	export default {
		components: {
			addOrUpdate,hourOrUpdate
		},
		data() {
			return {
			  campusList:[],
				p: {		// 查询参数
					name: '',
					pageNo: 1,
					pageSize: 10,
          campus:'',
          status:0
				},
				dataCount: 0,
				dataList: [],		// 数据集合
			}
		},
		methods: {
			// 刷新
			f5: function(){
        this.getCampusList();
        let data = {
          name:this.p.name,
          pageNum:(this.p.pageNo - 1) * this.p.pageSize,
          pageSize:this.p.pageSize,
          campus:this.p.campus,
          status:this.p.status
        }
				this.sa.ajax('api/psdAdmin/stu/getStudentList',
            data,
            function(res){
				  if(res.code == 0) {
            this.dataList = res.data.data;	// 数据
            this.dataCount = res.data.pageCount;	// 分页
            console.log(res.data);
          }else{
            this.dataList=[];
            this.dataCount=0;
            this.sa.error(res.msg || '会员列表获取失败');
          }
				}.bind(this)/*, {res: mockDataList}*/);
			},
      getCampusList:function (){
        this.sa.ajax('api/psdAdmin/campus/getList',
            {},
            function(res){
              this.campusList = res.data;
              console.log('校区',res.data);
            }.bind(this),{async:false});
      },
			// 添加
			add: function () {
				this.$refs['add-or-update'].open(0);
			},
			// 修改
			update: function (data) {
				this.$refs['add-or-update'].open(data.id);
			},
      // 修改
      updateHour: function (data) {
        this.$refs['hour-or-update'].open(data.id);
      },
			// 删除
			del: function (data) {
				this.sa.confirm('是否删除，此操作不可撤销', function() {
					this.sa.ajax2('/goods/delete?id=' + data.id, function() {
						this.sa.arrayDelete(this.dataList, data);
						this.sa.ok('删除成功');
					}.bind(this))
				}.bind(this));
			},
      getCampusName: function (value) {
        for(let i=0;i<this.campusList.length;i++){
          if(this.campusList[i].id == value){
            return this.campusList[i].name;
          }
        }
        return value;
      },
      getVipInfo:function(vip){
			  var des="错误";
			  switch (vip){
			    case 1:
            des =  "无折扣";
            break;
          case 2:
            des =  "九折";
            break;
          case 3:
            des = "八五折";
            break;
          case 4:
            des = "八折";
            break;
          case 5:
            des = "七折";
            break;
        }
        if(vip>5){
          des="七折";
        }
        return des;
      },
      changeStatus:function (id,status){
			  let _this = this;
			  if(status == 0){
          this.sa.confirm("确定禁用该学生吗",function (){
            console.log("禁用");
            _this.sa.ajax('api/psdAdmin/stu/updateStudentStatus',
                {id:id,status:'1'},
                function(res){
                  if(res.code=='0'){
                    _this.sa.alert("已禁用",function (){
                      _this.f5();
                    });
                  }else{
                    _this.sa.error("禁用失败");
                  }
                }.bind(this));
          });
        }else{
          this.sa.confirm("确定启用该学生吗",function (){
            _this.sa.ajax('api/psdAdmin/stu/updateStudentStatus',
                {id:id,status:'0'},
                function(res){
                  if(res.code=='0'){
                    _this.sa.alert("已启用",function (){
                      _this.f5();
                    });

                  }else{
                    _this.sa.error("启用失败");
                  }
                }.bind(this));
          });
        }
      }
		},
		created: function(){
			this.f5();
			// this.$notify.info({
			// 	title: '消息',
			// 	message: '本页面展示表格的常见显示方式'
			// });
		},
    filters: {

    }
	}
</script>
